import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';

 import Home from './pages/Home';
 import About from './pages/About';
import Services from './pages/Services';
import ServiceDetails from "./components/Services/ServiceDetails";
//import Products from './pages/Products';
 import Contact from './pages/Contact';
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard'; // ✅ add this import
import VerifyCertificate from './components/VerifyCertificate/VerifyCertificate';


function App() {
  return (
    <Router>
      <Navbar />
       <ScrollToTop />
       <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
         <Route path="/services" element={<Services />} />
         <Route path="/services/:id" element={<ServiceDetails />} />
         {/* <Route path="/products" element={<Products />} />  */}
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/login" element={<Login />} /> 
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/verify-certificate" element={<VerifyCertificate />} />
       
      </Routes>
     <Footer /> 
    </Router>
  );
}

export default App;
